<template>
	<div class="not-found">
		<v-row>
			<v-col cols="12" class="text-center">
				<div>
					<img width="520" style="height: auto;max-width: 100%;" src="/assets/ilustration/maintenance.svg">
				</div>
				<div class="pt-1-rem font-size-22 font-weight-bold orange--text darken-4 text-uppercase mt-5">Sedang Dalam Perbaikan!</div>
				<div class="pt-1-rem font-size-13 font-weight-bold cl-secondary mt-2">Saat ini website tidak tersedia untuk diakses.<br>Kami sedang melakukan perbaikan atau mungkin beberapa update untuk kinerja yang lebih baik lagi.</div>
				<div class="font-size-13 font-weight-bold cl-secondary">Mohon maaf atas ketidaknyamanan ini.</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
export default {
	created() {
		this.$store.dispatch('setPageTitle', `404`)
	}
};
</script>

<style>
.not-found {
	/* font-family: "Roboto", sans-serif !important; */
	font-family: 'Mulish', sans-serif;
}
.text-center {
	text-align: center;
}
.font-size-1-rem {
	font-size: 1rem;
}
.font-size-16 {
	font-size: 16pt;
}
.font-italic {
	font-style: italic;
}
.font-weight-bold {
	font-weight: bold;
}
.pt-1 {
	padding-top: 4px;
}
.pt-2 {
	padding-top: 8px;
}
.pt-1-rem {
	padding-top: 1rem;
}
.color-grey {
	color: grey;
}
.bg-purple {
	background-color: #512DA8 !important;
	color: white !important;
}
.text-deco {
	text-decoration: none;
}
</style>